import {Popup} from "react-map-gl/maplibre"
import styled from "styled-components"
import dayjs from "dayjs"

const ArrowPopup = ({data}) => {

	if (!data) return null

	const date = dayjs().startOf("day").add(data.duration, "second")

	return (
		<PopupWrapper
			latitude={data.location[0]}
			longitude={data.location[1]}
			closeButton={false}
			className="no-pointer-events-popup"
		>
			<Wrapper>
				<Time>
					{date.format('Сегодня в HH:mm')}<sup>:{date.format('ss')}</sup>
				</Time>
				<Speed>
					{data.speed} км/ч
				</Speed>
			</Wrapper>
		</PopupWrapper>
	)
}

export default ArrowPopup

const PopupWrapper = styled(Popup)`
    min-width: 250px;
    max-width: 250px;
    color: #000000;
    font-size: 14px;
`
const Wrapper = styled.div`
    display: flex;
    flex: 1;
    pointer-events: none;
`

const Time = styled.div`
    display: flex;
    flex: 1;
    font-weight: bold;

    sup {
        top: 2px;
    }
`
const Speed = styled.div`
    margin-left: 20px;
`
